import React, { useEffect, useState } from "react";
import { useGetAllUsers } from "../../queryHooks";
import qs from "qs";

//  Component starts
const SearchUserBox = ({ searchedUsers = () => {} }) => {
	const [searchedVal, setSearchedVal] = useState("");
	const [users, setUsers] = useState([]);
	const [allUsersPayload, setAllUsersPayload] = useState({
		pagination: false,
		sort: { first_name: "ASC" },
	});

	const { data: dataGetAllUsers } = useGetAllUsers(
		qs.stringify(allUsersPayload)
	);

	useEffect(() => {
		if (dataGetAllUsers && dataGetAllUsers.data?.records) {
			let _users = [];
			dataGetAllUsers.data.records.forEach((element) => {
				_users.push({
					label: `${element.first_name} ${element.last_name}`,
					value: JSON.stringify({
						id: element.id,
						name: `${element.first_name} ${element.last_name}`,
					}),
				});
			});
			if (searchedVal.length) setUsers(_users);
			else setUsers([]);
		}
	}, [dataGetAllUsers]);

	useEffect(() => {
		const timer = setTimeout(() => {
			setAllUsersPayload({
				...allUsersPayload,
				search: {
					first_name: searchedVal,
					last_name: searchedVal,
				},
			});
		}, 50);

		return () => clearTimeout(timer);
	}, [searchedVal]);

	useEffect(() => {
		searchedUsers(users);
	}, [users]);

	return (
		<>
			<div className="row mb-2">
				<div className="col-sm-12 position-static">
					<div className="search position-relative has-icon-left">
						<input
							type="search"
							className="form-control text-none"
							placeholder="Search"
							value={searchedVal}
							onChange={(e) => {
								setSearchedVal(e.target.value);
							}}
						/>
						<div className="form-control-position">
							<span className="bx bx-search"></span>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default SearchUserBox;
